//  ##  ##     ##              ###    ##     ##  ##  ###    ###  #####
//  ##  ####   ##             ## ##   ####   ##  ##  ## #  # ##  ##
//  ##  ##  ## ##  ########  ##   ##  ##  ## ##  ##  ##  ##  ##  #####
//  ##  ##    ###            #######  ##    ###  ##  ##      ##  ##
//  ##  ##     ##            ##   ##  ##     ##  ##  ##      ##  #####
/*
画面に入った監視対象に.animatedを付加
animatedによってアニメーションするクラスは_anime.scssとそのスタイルガイドを参照
*/
window.intObs = function () {
  if (!document.getElementsByClassName('js-in')[0]) {
    return
  }
  const intObsOption = {
    // root: document.querySelector('#obsArea'), // 監視領域 省略でビューポート
    rootMargin: '0px 0px -20% 0px', // 指定px,%分判定領域を増減する -50% 0pxで画面中央の走査線になる
    threshold: 0, // 発火判定の閾値 0.1=10%以上交差で発火 0で接触次第発火
  }
  const observer = new IntersectionObserver(intObsCallback, intObsOption)
  const intObsItems = document.querySelectorAll('.js-in:not(.animated)')
  for (let index = 0; index < intObsItems.length; index++) {
    const intObsItem = intObsItems[index]
    observer.observe(intObsItem) // 監視対象に加える
  }
  function intObsCallback(entries) {
    for (let index = 0; index < entries.length; index++) {
      const entry = entries[index]
      const entryItem = entry.target
      if (entry.isIntersecting) {
        entryItem.classList.add('animated')
        // observer.unobserve(entryItem) // 監視対象から外す
      } else {
        entryItem.classList.remove('animated')
      }
    }
  }
}

// SP版限定の画面交差監視
window.intObsSP = function () {
  // SP版判定（1024px以下）
  const isSP = window.innerWidth <= 1024
  if (!isSP) {
    return
  }
  if (!document.getElementsByClassName('js-in-sp')[0]) {
    return
  }
  const intObsOption = {
    // root: document.querySelector('#obsArea'), // 監視領域 省略でビューポート
    rootMargin: '0px 0px -30% 0px', // SP版は判定領域を調整
    threshold: 0, // 発火判定の閾値 0.1=10%以上交差で発火 0で接触次第発火
  }
  const observer = new IntersectionObserver(intObsCallback, intObsOption)
  const intObsItems = document.querySelectorAll('.js-in-sp:not(.animated)')
  for (let index = 0; index < intObsItems.length; index++) {
    const intObsItem = intObsItems[index]
    observer.observe(intObsItem) // 監視対象に加える
  }
  function intObsCallback(entries) {
    for (let index = 0; index < entries.length; index++) {
      const entry = entries[index]
      const entryItem = entry.target
      if (entry.isIntersecting) {
        entryItem.classList.add('animated')
        // observer.unobserve(entryItem) // 監視対象から外す
      } else {
        entryItem.classList.remove('animated')
      }
    }
  }
}

window.intObs() // 画面交差API起動
window.intObsSP() // SP版限定の画面交差API起動